import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/my/leaves/new',
}).lazy(() => import('./new.lazy').then((d) => d.Route))
